module.exports = __webpack_public_path__ + "media/images/icons/cost-973342ff089585996177f9ce4aaa718b.png";